(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-gallery-pro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript.closest('.svc-gallery-pro');
  const modal = root.querySelector('.svc-lightbox');
  if (!modal) return;
  const img = modal.querySelector('.svc-lightbox__img');
  const closeEls = modal.querySelectorAll('[data-close]');
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('.svc-gallery-pro__btn');
    if (!btn) return;
    img.src = btn.getAttribute('data-full');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  });
  const close = () => {
    modal.hidden = true;
    img.src = '';
    document.body.style.overflow = '';
  };
  closeEls.forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
})();

  } catch(e) { console.error(e); }
})();
})();
